/** Provider brand marks. Brand colours are the logos themselves, not theme colours. */
export function GmailLogo({ className = 'w-5 h-5' }: { className?: string }) {
  return (
    <svg viewBox="0 0 52 40" className={className} aria-hidden="true">
      <path d="M3.5 40h8.1V19.6L0 10.9v25.6C0 38.4 1.6 40 3.5 40z" fill="#4285f4" />
      <path d="M40.4 40h8.1c1.9 0 3.5-1.6 3.5-3.5V10.9l-11.6 8.7z" fill="#34a853" />
      <path d="M40.4 3.5v16.1L52 10.9V5.2c0-4.3-4.9-6.8-8.4-4.2z" fill="#fbbc04" />
      <path d="M11.6 19.6V3.5L26 14.4 40.4 3.5v16.1L26 30.5z" fill="#ea4335" />
      <path d="M0 5.2v5.7l11.6 8.7V3.5L8.4 1C4.9-1.6 0 .9 0 5.2z" fill="#c5221f" />
    </svg>
  );
}

export function GoogleLogo({ className = 'w-5 h-5' }: { className?: string }) {
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
      <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" />
      <path fill="#FF3D00" d="m6.3 14.7 6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
      <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z" />
      <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z" />
    </svg>
  );
}

export function MicrosoftLogo({ className = 'w-5 h-5' }: { className?: string }) {
  return (
    <svg viewBox="0 0 23 23" className={className} aria-hidden="true">
      <path fill="#f25022" d="M1 1h10v10H1z" />
      <path fill="#7fba00" d="M12 1h10v10H12z" />
      <path fill="#00a4ef" d="M1 12h10v10H1z" />
      <path fill="#ffb900" d="M12 12h10v10H12z" />
    </svg>
  );
}

export function OneDriveLogo({ className = 'w-5 h-5' }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 22" className={className} aria-hidden="true">
      <path fill="#0364b8" d="M12.2 6.6A8.5 8.5 0 0 1 27.3 9a6 6 0 0 1 4.6 9.3L20 13.3z" />
      <path fill="#0078d4" d="M9.6 5.4a8 8 0 0 1 2.6.5L20 13.3 6.3 19.8A6 6 0 0 1 3 9.1a8 8 0 0 1 6.6-3.7z" />
      <path fill="#1490df" d="M27.3 9H27a6 6 0 0 0-2.4.5l-4.6 3.8 7.4 8.7h4.6a6 6 0 0 0 0-13z" />
      <path fill="#28a8ea" d="M6.3 19.8A6 6 0 0 0 9 22h22.6a6 6 0 0 0 .3-3.7L20 13.3z" />
    </svg>
  );
}

export function OutlookLogo({ className = 'w-5 h-5' }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
      <rect x="10" y="4" width="20" height="24" rx="2" fill="#0a5ca8" />
      <path fill="#28a8ea" d="M10 4h20v8H10z" />
      <path fill="#0078d4" d="M10 12h20v8H10z" />
      <rect x="2" y="8" width="16" height="16" rx="2" fill="#0f6cbd" />
      <ellipse cx="10" cy="16" rx="4" ry="4.6" fill="none" stroke="#fff" strokeWidth="2" />
    </svg>
  );
}
